// src/app/hooks/er_wheel/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useGetErWheelParamsQuery,
  useGetFanLocationsQuery,
  useGetFlowTypesQuery,
  useLazyGetErWheelCertificationsQuery,
  useLazyGetErWheelQuery,
} from '../../services';
import { setErWheel, setErWheelParams } from '../../slices';

export const useGetErWheelMainData = (id: number) => {
  const { isLoading: erWheelLoading } = useGetErWheel(id);
  const { isLoading } = useGetErWheelParams();

  return {
    isLoading: isLoading || erWheelLoading,
  };
};

export const useGetErWheel = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getErWheel, { data: erWheel, isLoading }] = useLazyGetErWheelQuery();
  const [
    getErWheelCertifications,
    { data: certifications, isLoading: certificationsLoading },
  ] = useLazyGetErWheelCertificationsQuery();

  useEffect(() => {
    if (fetch && id) {
      getErWheel(id);
      getErWheelCertifications(id);
    }
  }, [id]);

  useEffect(() => {
    if (erWheel && certifications) dispatch(setErWheel({ ...erWheel, certifications }));
  }, [erWheel, certifications]);

  return {
    erWheel,
    isLoading,
    certificationsLoading,
    getErWheel,
    getErWheelCertifications,
  };
};

export const useGetErWheelParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetErWheelParamsQuery();
  const { data: flow_types } = useGetFlowTypesQuery();
  const { data: fan_locations } = useGetFanLocationsQuery();

  useEffect(() => {
    if (params && flow_types && fan_locations) {
      dispatch(
        setErWheelParams({ ...params.er_wheel, flow_types, fan_locations })
      );
    }
  }, [params, flow_types, fan_locations]);

  return { isLoading, params, get: refetch };
};
